module.exports = __webpack_public_path__ + "static/media/radar_ag.fc988c61.png";